import React from 'react';
import './BCSChartModal.css';

interface BCSChartModalProps {
  onClose: () => void;
}

const BCSChartModal: React.FC<BCSChartModalProps> = ({ onClose }) => {
  return (
    <div className="bcs-modal-overlay" onClick={onClose}>
      <div className="bcs-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="bcs-modal-header">
          <h2>Body Condition Score (BCS) Chart</h2>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="bcs-modal-body">
          <p className="bcs-intro">
            Body Condition Score (BCS) is a standardized method to assess your dog's weight status. 
            Use the chart below to determine your dog's current condition.
          </p>

          <div className="bcs-image-container">
            <img 
              src="/dogweight.png" 
              alt="Dog Body Condition Score Chart" 
              className="bcs-chart-image"
            />
          </div>

          <div className="bcs-tips">
            <h3>Assessment Tips:</h3>
            <ul>
              <li>Feel your dog's ribs with flat hands - you should feel them easily with minimal pressure at ideal weight</li>
              <li>Observe your dog from above - an ideal weight dog should have a visible waist</li>
              <li>Look at your dog from the side - an ideal weight dog should have an abdominal tuck</li>
              <li>If ribs, spine, or pelvic bones are easily visible, your dog may be underweight.</li>
              <li>If you cannot easily feel ribs or see a waist/abdominal tuck, your dog may be overweight.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BCSChartModal;

